import React, { createContext, useContext, useMemo, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { emptyWizardForm } from './postJobWizardSchema';
import { usePostJobWizardAutoSave } from './usePostJobWizardAutoSave';
import { usePostJobWizardState } from './usePostJobWizardState';

const JobWizardContext = createContext(null);

export function JobWizardProvider({ children }) {
  const { token } = useAuth();
  const [jobId, setJobId] = useState(null);
  const [form, setForm] = useState(emptyWizardForm);

  const autoSave = usePostJobWizardAutoSave({ token, jobId, setJobId, setForm });

  const wizard = usePostJobWizardState({
    token,
    jobId,
    setJobId,
    form,
    setForm,
    persistDraft: autoSave.persistDraft,
    ensureJobId: autoSave.ensureJobId,
    bindFormRef: autoSave.bindFormRef,
    setSaveError: autoSave.setSaveError,
    setSaving: autoSave.setSaving,
  });

  const value = useMemo(
    () => ({
      ...wizard,
      saving: autoSave.saving,
      saveError: autoSave.saveError,
      lastSavedAt: autoSave.lastSavedAt,
    }),
    [wizard, autoSave.saving, autoSave.saveError, autoSave.lastSavedAt]
  );

  return <JobWizardContext.Provider value={value}>{children}</JobWizardContext.Provider>;
}

export function useJobWizard() {
  const ctx = useContext(JobWizardContext);
  if (!ctx) {
    throw new Error('useJobWizard must be used within JobWizardProvider');
  }
  return ctx;
}
